
import { Component, Vue } from 'vue-property-decorator';
import OrderSearch from './components/OrderSearchCustom.vue';
import OrderList from './components/OrderList.vue';
import { ViewType, OrderServiceStage } from '@/types/orderServicer';

@Component({
  name: 'orderServicerSettlement',
  components: {
    OrderSearch,
    OrderList
  }
})
export default class extends Vue {
  private stage = OrderServiceStage.SERVICE_STAGE_FINISH;
  private vt = ViewType.ORDER_SERVICER_COMPLETED_SETTLE;
}
